import React from "react";
import Loader from "./Loader";
import "../styles/components/loader.scss";

const LoadingPage = () => (
  <div className="loader">
    <Loader />
  </div>
);

export default LoadingPage;
